module.exports = __webpack_public_path__ + "static/media/lasso-plus.edf8777a.webp";